import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import Icon from 'UI/FontAwesomeIcon'
import { DESTROY_MONITORING_TYPE } from './queries'
import { Query } from '../../../utilities/incognitaAPI'
import { isNull } from 'lodash'

const DeletePopup = ({
  monitoringType,
  setMonitoringType,
  getMonitoringTypes,
  setAlert
}) => {
  const [loading, setLoading] = useState(false)

  const handleClose = () => setMonitoringType(undefined)

  const destroy = () => {
    setLoading(true)

    Query(DESTROY_MONITORING_TYPE, { id: monitoringType.id })
      .then(res => {
        if(isNull(res.destroyLogicmonitorMonitoringType.errors)) {
          setLoading(false)
          setMonitoringType(undefined)
          getMonitoringTypes()
          setAlert({
            text: `Monitoring type ${monitoringType.monitoringType} has been successfully deleted!`,
            variant: 'success'
          })
        }
      }).finally(() => {  
        setLoading(false)
      })
  }

    return (
      <div
        className="modal show"
        style={{ display: 'block', position: 'initial' }}
      >
        <Modal show={monitoringType} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Are you sure?</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            Are you sure you want to remove
            <b> {monitoringType?.monitoringType} </b>
            monitoring type?
          </Modal.Body>

          <Modal.Footer>
            <Button variant="outline-primary" onClick={handleClose}>
              Cancel
            </Button>

            <Button variant="danger" onClick={destroy}>
              {loading && <Icon className="mr-1 animate-spin" icon="spinner" />}
              Remove
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
}

export default DeletePopup
